import { Alert, Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import type { Lesson } from '@/types'

type Props = {
  lesson: Lesson
  isTeacher: boolean
  onOpenPaymentModal?: () => void
}

export function LessonPaymentBanner({ lesson, isTeacher, onOpenPaymentModal }: Props) {
  const { t } = useTranslation()

  if (!isTeacher || lesson.status !== 'completed') return null
  if (lesson.payment_status !== 'pending') return null

  return (
    <Alert
      severity="warning"
      sx={{ mb: 2 }}
      action={
        onOpenPaymentModal ? (
          <Button color="inherit" size="small" onClick={onOpenPaymentModal}>
            {t('billing.finalizePayment', 'Закрыть оплату')}
          </Button>
        ) : undefined
      }
    >
      {t('billing.paymentPendingBanner', 'Финансовое закрытие требуется')}
    </Alert>
  )
}
